<div class="profile_information--mi-container">
  <div class="profile_information--input-container">
    <div class="profile_information--input-label">
      {{ title }}
    </div>
    <select class="profile_information--wrapped-input" [(ngModel)]="value">
      <option value="">{{ placeholder | translate }}</option>
      @for (item of data ?? []; track item) {
        <option [value]="item.value">
          {{ item.label || item.value }}
        </option>
      }
    </select>
    <fa-icon [icon]="faChevronDown"></fa-icon>
  </div>
  @if (value.length) {
    <button
      type="button"
      (click)="addNewMiValue()"
      appButton="small"
      i18n="@@ProfileInformation-AddNew"
    >
      Add New
    </button>
  }
</div>
